import axios from "axios";
/** Services Import */
import IndexedDb from "../IndexedDb/IndexedDb";
import _ from "lodash";
import { toast } from "react-toastify";

const Commons = {
  // 현재 화면의 너비와 높이 반환 함수
  Dimentions: () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  },

  // 모바일인지 Check, mobile => true
  IsMobile: () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },

  // String change function
  ChangeString: (_data, _type = "trim") => {
    if (_data.lenght < 1) {
      return "";
    }

    const data = _data.toString();

    switch (_type) {
      case "trim":
        return data.trim();
      case "lTrim":
        return data.trimStart();
      case "rTrim":
        return data.trimEnd();
      case "toInt":
        if (!parseInt(data)) {
          return 0;
        } else {
          return parseInt(data);
        }
      case "toFloat":
        if (!parseFloat(data)) {
          return 0;
        } else {
          return parseFloat(data);
        }
      case "upper":
        return data.toUpperCase();
      case "lower":
        return data.toLowerCase();
    }
  },

  // 숫자 100단위 마다 콤마 추가
  AddComma: (price) => {
    let returnString = price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return returnString;
  },

  // Date 포멧을 바꾸는 function
  DateFormating: (_date, _type = 1) => {
    var dateString = null;
    if (_date && _date.length < 9) {
      const tdata = new Date();
      let tyear = tdata.getFullYear();
      let tmonth = tdata.getMonth() + 1;
      let tday = tdata.getDate();
      let thour = tdata.getHours();
      let tmin = tdata.getMinutes();
      let tsec = tdata.getSeconds();
      if (_date.length == 8) {
        tyear = _date.substring(0, 4);
        tmonth = _date.substring(4, 6);
        tday = _date.substring(6, 8);
        dateString = new Date(tyear, tmonth - 1, tday);
      } else if (_date.length == 6) {
        thour = _date.substring(0, 2);
        tmin = _date.substring(2, 4);
        tsec = _date.substring(4, 6);
        dateString = new Date(tyear, tmonth - 1, tday, thour, tmin, tsec);
      } else {
        return "";
      }
    } else if (!_date) {
      return "";
    }

    const data =
      dateString != null && dateString != "Invalid Date"
        ? dateString
        : new Date(_date);
    let year = data.getFullYear();
    let month = data.getMonth() + 1;
    let date = data.getDate();
    let hour = data.getHours();
    let min = data.getMinutes();
    let sec = data.getSeconds();

    switch (_type) {
      case 0:
        return data;
      case 1: // YYYY-MM-dd HH:mm:ss
        return (
          year +
          "-" +
          month.toString().padStart(2, "0") +
          "-" +
          date.toString().padStart(2, "0") +
          " " +
          hour.toString().padStart(2, "0") +
          ":" +
          min.toString().padStart(2, "0") +
          ":" +
          sec.toString().padStart(2, "0")
        );
      case 11: // YYYY-MM-ddTHH:mm:ss
        return (
          year +
          "-" +
          month.toString().padStart(2, "0") +
          "-" +
          date.toString().padStart(2, "0") +
          "T" +
          hour.toString().padStart(2, "0") +
          ":" +
          min.toString().padStart(2, "0") +
          ":" +
          sec.toString().padStart(2, "0")
        );
      case 2: // YYYY-MM-dd
        return (
          year +
          "-" +
          month.toString().padStart(2, "0") +
          "-" +
          date.toString().padStart(2, "0")
        );
      case 22: // MM-dd
        return (
          month.toString().padStart(2, "0") +
          "-" +
          date.toString().padStart(2, "0")
        );
      case 3: // YYYY/MM/dd/HH:mm:ss
        return (
          year +
          "/" +
          month.toString().padStart(2, "0") +
          "/" +
          date.toString().padStart(2, "0") +
          "/ " +
          hour.toString().padStart(2, "0") +
          ":" +
          min.toString().padStart(2, "0") +
          ":" +
          sec.toString().padStart(2, "0")
        );
      case 4: // YYYY/MM/dd
        return (
          year +
          "/" +
          month.toString().padStart(2, "0") +
          "/" +
          date.toString().padStart(2, "0")
        );
      case 44: // MM/dd
        return (
          month.toString().padStart(2, "0") +
          "/" +
          date.toString().padStart(2, "0")
        );
      case 5: // YYYYMMddHHmmss
        return (
          year.toString() +
          month.toString().padStart(2, "0") +
          date.toString().padStart(2, "0") +
          hour.toString().padStart(2, "0") +
          min.toString().padStart(2, "0") +
          sec.toString().padStart(2, "0")
        );
      case 6: // YYYYMMdd
        return (
          year.toString() +
          month.toString().padStart(2, "0") +
          date.toString().padStart(2, "0")
        );
      case 7: // HHmmss
        return (
          hour.toString().padStart(2, "0") +
          min.toString().padStart(2, "0") +
          sec.toString().padStart(2, "0")
        );
      case 77: // HH:mm:ss
        return `${hour.toString().padStart(2, "0")}:${min
          .toString()
          .padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
      case 8: // YYYYMM
        return year.toString() + month.toString().padStart(2, "0");
      case 88: // YYYY/MM
        return `${year.toString()}/${month.toString().padStart(2, "0")}`;
      case 9: // YYYY
        return year.toString();
      case 99: // HH:mm
        return `${hour.toString().padStart(2, "0")}:${min
          .toString()
          .padStart(2, "0")}`;
    }
  },

  // 두 날짜 사이의 차
  DateDiff: (_date1, _date2, _type = "D") => {
    const date1 = new Date(_date1);
    const date2 = new Date(_date2);
    const diffDate = date1.getTime() - date2.getTime();
    let returnDate = null;

    switch (_type) {
      case "D":
        returnDate = Math.abs(diffDate / (1000 * 60 * 60 * 24));
        break;
      case "M":
        returnDate = Math.floor(
          Math.abs(diffDate / (1000 * 60 * 60 * 24 * 30))
        );
        break;
      case "Y":
        returnDate = Math.floor(
          Math.abs(diffDate / (1000 * 60 * 60 * 24 * 365))
        );
        break;
    }
    return returnDate;
  },

  // 현재 일자에서 계산 값을 리턴하는 함수
  DateCalcular: (_num = 0, _code = "M") => {
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();
    let result;

    switch (_code) {
      case "Y":
        if (_num != 0) {
          if (_num < 0) {
            result =
              year +
              _num +
              "-" +
              month.toString().padStart(2, "0") +
              "-" +
              day.toString().padStart(2, "0") +
              " 00:00:00";
          } else {
            result =
              year +
              _num +
              "-" +
              month.toString().padStart(2, "0") +
              "-" +
              day.toString().padStart(2, "0") +
              " 23:59:59";
          }
        }
        break;
      case "M":
        if (_num != 0) {
          if (_num < 0) {
            result =
              year +
              "-" +
              (month + _num).toString().padStart(2, "0") +
              "-" +
              day.toString().padStart(2, "0") +
              " 00:00:00";
          } else {
            result =
              year +
              "-" +
              (month + _num).toString().padStart(2, "0") +
              "-" +
              day.toString().padStart(2, "0") +
              " 23:59:59";
          }
        }
        break;
      case "D":
        if (_num != 0) {
          if (_num < 0) {
            result =
              year +
              "-" +
              month.toString().padStart(2, "0") +
              "-" +
              (day + _num).toString().padStart(2, "0") +
              " 00:00:00";
          } else {
            result =
              year +
              "-" +
              month.toString().padStart(2, "0") +
              "-" +
              (day + _num).toString().padStart(2, "0") +
              " 23:59:59";
          }
        }
        break;
    }

    return result;
  },

  // 객체 배열 중복 제거
  Deduplication: (_arr = []) => {
    let uniqArr = _arr.reverse().reduce((acc, current) => {
      const uniq = acc.find((item) => item.rowIdx === current.rowIdx);
      if (!uniq) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return uniqArr;
  },

  // 객체 배열 중복 제거2
  Deduplication: (_arr = [], _keys) => {
    return _.unionBy(_arr.reverse(), _keys);
  },

  // Grid insert rows number
  InsertNumber: (_arr = []) => {
    let newArr = [];
    if (_arr.length > 0) {
      _arr.forEach((item, index) => {
        newArr.push({
          ...item,
          no: index + 1,
        });
      });

      return newArr;
    } else {
      return false;
    }
  },

  // Local Storage get/set/remove/clear return function
  Storages: (_type, _name, _data) => {
    switch (_type) {
      case "get":
        if (_name) {
          return JSON.parse(window.localStorage.getItem(_name));
        } else {
          return "error";
        }
      case "set":
        if (_name && _data) {
          window.localStorage.setItem(_name, JSON.stringify(_data));
          break;
        } else {
          return "error";
        }
      case "remove":
        if (_name) {
          window.localStorage.removeItem(_name);
          break;
        } else {
          return "error";
        }
      case "clear":
        window.localStorage.clear();
        break;
    }
  },

  // Ajax(Axios)의 Header 부분만 가져오는 함수
  GetHeaders: async () => {
    return await IndexedDb.GetLoginInfo().then((result) => {
      const token = result.token;
      const headers = {
        // "Content-Type": `application/json`,
        Authorization: "Bearer " + token,
      };
      return headers;
    });
  },

  //Axios get/post response function
  Axios: async (_type = "get", _url, _params, _bodys = null) => {
    let token = null;
    try {
      switch (_type) {
        case "getOther":
          return await axios.get(_url, {
            headers: {
              "Content-Type": `application/json`,
            },
            withCredentials: false,
            params: _params,
          });
        case "postOther":
          return await axios.post(_url, _bodys, {
            headers: {
              "Content-Type": `application/json`,
            },
            withCredentials: false,
            params: _params,
          });
        case "postOtherMultipart":
          return await axios.post(_url, _bodys, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            withCredentials: false,
            params: _params,
          });
        // 로그인없잉
        case "getWithoutLogin":
          return await axios.get(_url, {
            headers: {
              "Content-Type": `application/json`,
            },
            params: _params,
          });
        // 로그인사용
        case "get":
          await IndexedDb.GetLoginInfo().then((result) => {
            token = result.token;
          });

          return await axios.get(_url, {
            headers: {
              "Content-Type": `application/json`,
              Authorization: "Bearer " + token,
            },
            params: _params,
          });

        case "postMultipart":
          await IndexedDb.GetLoginInfo().then((result) => {
            token = result.token;
          });
          return await axios.post(_url, _bodys, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + token,
            },
            params: _params,
          });
        case "post":
          await IndexedDb.GetLoginInfo().then((result) => {
            token = result.token;
          });

          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              "Content-Type": `application/json`,
              Authorization: "Bearer " + token,
            },
            params: _params,
          });
        case "post1":
          await IndexedDb.GetLoginInfo().then((result) => {
            token = result.token;
          });

          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              "Content-Type": `application/json`,
              Authorization: "Bearer " + token,
            },
            params: !_bodys ? _params : "",
          });
        case "login":
          return await axios.post(_url, _params, {
            Headers: {
              headers: { "Content-Type": `application/json` },
            },
            body: _params,
          });
        case "logout":
          window.localStorage.removeItem("userInfo");
          window.localStorage.setItem(
            "authorization",
            JSON.stringify({
              authorization: false,
              authDate: Commons.DateFormating(new Date()),
            })
          );
          await IndexedDb.ClearDb("LoginInfo");
          await IndexedDb.ClearDb("MenuList");
          await IndexedDb.ClearDb("AuthList");
          const naverAccessToken = localStorage.getItem("accessNaver");
          const kakaoAccessToken = localStorage.getItem("accessKakao");

          window.localStorage.removeItem("accessNaver");
          window.localStorage.removeItem("accessKakao");

          // 구글 로그아웃 처리
          if (window.gapi && window.gapi.auth2) {
            const auth2 = window.gapi.auth2.getAuthInstance();
            if (auth2) {
              await auth2.signOut();
              console.log("Google user signed out.");
            }
          }

          // 네이버 로그아웃 처리
          if (naverAccessToken) {
            const naverResponse = await axios.post(
              `https://nid.naver.com/oauth2.0/token?grant_type=delete&client_id=${
                import.meta.env.VITE_NAVER_CLIENT_ID
              }&client_secret=${
                import.meta.env.VITE_NAVER_SECRET_KEY
              }&access_token=${naverAccessToken}&service_provider=NAVER`,
              null,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            );
            if (naverResponse.status === 200) {
              console.log("Naver user signed out.");
            } else {
              console.error(
                "Failed to log out of Naver:",
                naverResponse.statusText
              );
            }
          }

          // 카카오 로그아웃 처리
          if (kakaoAccessToken) {
            const kakaoResponse = await axios.post(
              `https://kapi.kakao.com/v1/user/logout`,
              null,
              {
                headers: {
                  Authorization: `Bearer ${kakaoAccessToken}`,
                },
              }
            );
            if (kakaoResponse.status === 200) {
              console.log("Kakao user signed out.");
            } else {
              console.error(
                "Failed to log out of Kakao:",
                kakaoResponse.statusText
              );
            }
          }
          window.open("/login", "_self");
        // await IndexedDb.deleteDatabase("Local_Vari");
      }
    } catch (e) {
      if (e.response.status == 401) {
        Commons.Axios("logout");
      }
    }
  },

  /**
   * Toast message function
   * @param {default, success, error, warn, info} _type
   * @param {*} _message
   * @param {top-left, top-right, top-center, bottom-left, bottom-right, bottom-center} _position
   * @param {Number | false} _autoClose
   * @param {boolean} _draggable
   */
  Toast: (
    _type = "default",
    _message,
    _position = "top-center",
    _autoClose = 3000,
    _draggable = true
  ) => {
    switch (_type) {
      case "success":
        toast.success(_message, {
          position: _position,
          autoClose: _autoClose,
          draggable: _draggable,
        });
        break;
      case "error":
        toast.error(_message, {
          position: _position,
          autoClose: _autoClose,
          draggable: _draggable,
        });
        break;
      case "warn":
        toast.warn(_message, {
          position: _position,
          autoClose: _autoClose,
          draggable: _draggable,
        });
        break;
      case "info":
        toast.info(_message, {
          position: _position,
          autoClose: _autoClose,
          draggable: _draggable,
        });
        break;
      default:
        toast(_message, {
          position: _position,
          autoClose: _autoClose,
          draggable: _draggable,
        });
        break;
    }
  },
};

export default Commons;
